import React, { useState, useRef } from "react";
import { Redirect } from "react-router-dom";
import Link from "@material-ui/core/Link";
import ReCAPTCHA from "react-google-recaptcha";
import { Formik } from "formik";
import { connect, useDispatch } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { TextField, Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { toAbsoluteUrl } from "../../../_metronic";
import * as Regex from "../../constants/Regexp";
import * as URI from "../../constants/uri";
import * as Globals from "../../constants/globals";
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import * as builder from "../../../_metronic/ducks/builder";
import Grid from "@material-ui/core/Grid";
import { alertBox } from "../../components/BoxProvider";
import {
  checkHttpStatus,
  get,
  post,
  enableSpinner,
  disableSpinner,
} from "../../utils/RestUtilsWithAxios";
import ChangePassword from "./partials/ChangePassword";
import { makeStyles } from "@material-ui/core/styles/index";
import { clearTimer, intervalFunc } from "../../utils/countDown";
import BirthDatePickerDialog from "../../components/BirthDatePickerDialog";

const useStyles = makeStyles((theme) => ({
  whiteText: {
    color: "white",
  },
  fontLight: {
    fontWeight: "lighter",
    fontSize: 15,
  },
  fontSize15: {
    fontSize: 15,
  },
}));

function Login(props) {
  const classes = useStyles();
  const { intl } = props;
  const theme = useTheme();
  const notxs = useMediaQuery(theme.breakpoints.up("sm"));
  const [loading, setLoading] = useState(false);
  const [firstLogin, setFirstLogin] = useState(false);
  const [showRegistration, setShowRegistration] = useState(false);
  const [edevletLogin, setEdevletLogin] = useState(false);
  const [loginLock, setLoginLock] = useState(false);
  const [checked, setCheckBox] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [approvedUserToken, setApprovedUserToken] = useState(null);
  const [valueType, setValueType] = useState("");
  const [valueForUnlock, setValueForUnlock] = useState("");
  const [countDown, setCountDown] = useState(false);
  const [sendCodeIsAbled,setSendCodeIsAbled] = useState(true);
  const [firstInitialize, setFirstInitialize] = useState(true);
  const [confirmCodeBlock, setConfirmCodeBlock] = useState(false);
  const [updatePassword, setUpdatePassword] = useState(false);
  const [expiredPassword, setExpiredPassword] = useState(false);
  const [debugMode, setDebugMode] = useState(false);
  const [showPassInfo, setShowPassInfo] = React.useState(false);
  const dispatch = useDispatch();
  const [waitingCaptchaService, setWaitingCaptchaService] = useState(false);
  const [validUser, setValidUser] = useState(false);
  const [captchaCount, setCaptchaCount] = useState(0);
  const [getPublicSiteKey, setGetPublicSiteKey] = useState(true);
  const [siteKey, setSiteKey] = useState(null);
  const [investorType, setInvestorType] = useState(null);
  const [country, setCountry] = useState(null);
  const [smsIsAbled,setSmsIsAbled] = useState(false);
  const [epostaIsAbled,setEpostaIsAbled] = useState(false);
  // Üyeden eğer doğum tarihi istenirse
  const [memberState, setMemberState] = useState({
    isBirthDateOpen: false,
    memberId: "",
    birthDate:"",
    loading:false
  });

  /**
   * Captcha isaretlendiginde çalısan method
   */
  function handleOnChangeCaptcha() {
    if (captcha.current.getValue()) {
      console.log("Token var");
      setWaitingCaptchaService(true);

      post(URI.CAPTCHA, {
        token: captcha.current.getValue(),
        getPublicSiteKey: false,
      }).then(function(response) {
        if (response && response.data.serviceError === false) {
          console.log("Robot degilsin.");
          setValidUser(response.data.success);
          console.log("success : " + response.data.success);
          setWaitingCaptchaService(false);
        } else {
          console.log("Captcha service hata oluştu.");
          alertBox(
            "Hata",
            "Captcha servisinde beklenmedik bir hata oluştu. Daha sonra tekrar deneyiniz.",
            Globals.ALERT_ERROR,
            intl
          );
        }
      });
    }
  }

  /**
   * Captcha expired oldugunda calisan method
   */
  function expiredCaptcha() {
    console.log("captcha exp oldu.");
    setValidUser(false);
  }

  /**
   * Captcha resetlemek icin kullanilan method
   */
  function resetCaptcha() {
    if (captcha.current) {
      captcha.current.reset();
      setValidUser(false);
    }
  }

  /**
   * Captcha referansı
   */
  const captcha = useRef(null);

  /**
   * enableLoading - setLoading(true)
   */
  const enableLoading = () => {
    setLoading(true);
  };
  /**
   * disableLoading - setLoading(false)
   */
  const disableLoading = () => {
    setLoading(false);
  };
  /**
   * Sayfa ilk yuklendiginde backend den sitekey cekiliyor
   */
  React.useEffect(() => {
    post(URI.CAPTCHA, { getPublicSiteKey: getPublicSiteKey }).then(function(
      response
    ) {
      if (response) {
        console.log("publicSiteKey : " + response.data.publicSiteKey);
        setSiteKey(response.data.publicSiteKey);
        setGetPublicSiteKey(false);
      } else {
        console.log("backend gelen keyResponce hatalı.");
      }
    });
  }, []);


  React.useEffect(() => {
    handleEdevletLogIn()

    if (localStorage.getItem("rememberMe") === "true") {
      setCheckBox(true);
      document.getElementById("mkkSicilNo").value = localStorage.getItem(
        "mkkSicilNo"
      );
    }
    /**
     * enterPressed
     * @param event
     */
    const enterPressed = (event) => {
      var confirm = document.getElementById("form-dialog-title");
      var welcome = document.getElementById("form-dialog-title-2");
      if (confirm && event.keyCode === 13) {
        document.getElementById("approveButton").click();
      } else if (welcome && event.keyCode === 13) {
        document.getElementById("welcomeButton1").click();
      }
    };

    window.addEventListener("keydown", enterPressed);
    return () => {
      window.removeEventListener("keydown", enterPressed);
    };
  }, []);

  const failedLoginShownStatusUpdateCall=async()=>{
    get(URI.UPDATE_FAILED_LOGIN_SHOWN_STATUS);
  }


  const handleEdevletLogIn = async (birthDate, memberId) => {
  try {
    const searchStr = window.location.search;
    
    if (!searchStr || !searchStr.startsWith("?code=")) {
      console.log("Giriş için gerekli URL parametreleri bulunamadı.");
      // Debug mode gibi diğer kontrolleri burada yapabilirsiniz.
      if (searchStr === "?debugMode=true") {
        setDebugMode(true);
      }
      return; 
    }

    // 2. URL'den E-devlet verilerini ayrıştır.
    const params = new URLSearchParams(searchStr);
    const eGovernToken = params.get("code");
    const eGovernState = params.get("state");

    if (!eGovernToken || !eGovernState) {
        throw new Error("E-devlet token veya state bilgisi eksik.");
    }
    
    // E devlet
    const url = birthDate ? URI.BIRTHDATE_CONFIRM_LOGIN : URI.EDEVLET_CONFIRM_LOGIN;
    const postData = birthDate 
      ? { birthDate, tckn: memberId }
      : { edevletToken: eGovernToken, edevletState: eGovernState };

    const response = await post(url, postData);

    if (response.data.requiresBirthDate) {
      setMemberState(prevState => ({
        ...prevState,
        memberId: response.data.memberId,
        isBirthDateOpen: true 
      }));
    } else { 
      localStorage.setItem(Globals.TOKEN, response.data.token);
      localStorage.setItem("NameSurname", `${response.data.name} ${response.data.surname}`);
      localStorage.setItem("HelloMsgNameSurnameTitle", `Hoş geldiniz Sayın ${response.data.name} ${response.data.surname}`);
      localStorage.setItem("HelloMsg", response.data.helloMsg);
      localStorage.setItem("SicilNo", response.data.sicilNo);
      localStorage.setItem("InvestorType", response.data.investorType);
      localStorage.setItem("Country", response.data.country);
      localStorage.setItem("QualificationStat", response.data.qualificationStat);
      localStorage.setItem("IsExistsFailedLogin",String(!!response.data.existsFailedLogin));
      localStorage.setItem("FailedLoginDateList",JSON.stringify(response.data.failedLoginDateList || []));
      dispatch(auth.actions.setFooters(response.data.fundWarnMessageMap));

      if (response.data.status === Globals.UNREGISTERED_USER) {
        setShowRegistration(true);
      } else {
        setEdevletLogin(true);
        setFirstLogin(true);
        await getApproveCode(true);
      }
    }
  } catch (error) {
    console.error("handleEdevletLogIn sırasında bir hata oluştu:", error);
    checkHttpStatus(error, props.intl); 

    throw error;
  }
};

  const saveBirthDate = async () => {
  // 1. İşlem başladığında loading'i true yap
  setMemberState(prevState => ({
    ...prevState,
    loading: true,
    error: null, // Varsa eski hata mesajını temizle
  }));

  try {
    await handleEdevletLogIn(memberState.birthDate, memberState.memberId);

  } catch (error) {
    console.error("E-devlet doğrulama hatası:", error);
    setMemberState(prevState => ({
      ...prevState,
      error: "Doğrulama sırasında bir hata oluştu.", // Kullanıcıya gösterilecek hata mesajı
    }));

  } finally {
    // 4. İşlem başarılı da olsa, hata da olsa en sonunda burası çalışır
    setMemberState(prevState => ({
      ...prevState,
      loading: false, // Yükleme durumunu kapat
      isBirthDateOpen:false
    }));
  }
};

  /**
   * handleCheckBox - setCheckBox
   */
  function handleCheckBox() {
    setCheckBox(!checked);
  }

  /**
   * handleApproveCodeInput
   * @param event
   */
  const handleApproveCodeInput = (event) => {
    var inputTextVal = event.target.value;
    if (inputTextVal.length > 6) {
      document.getElementById("confirmCode").value = inputTextVal.substring(
        0,
        6
      );
    }
    var regEx = /[0-9]/g;
    if (!regEx.test(inputTextVal.charAt(inputTextVal.length - 1))) {
      document.getElementById("confirmCode").value = inputTextVal.substring(
        0,
        inputTextVal.length - 1
      );
    }
    var newVal = document.getElementById("confirmCode").value;
    var newReg = /^\d+$/;
    if (newVal.length > 0 && !newReg.test(newVal)) {
      document.getElementById("confirmCode").value = "";
    }
  };
  /**
   * timeIsUp - setCountDown(false)
   */
  const timeIsUp = () => {
    setCountDown(false);
    if (document.getElementById("infoArea3") === null) {
    } else {
      document.getElementById("infoArea3").innerHTML =
        "Süreniz dolmuştur.Yeni kod almak için " +
        "Onay Kodu Gönder butonunu tıklayınız:";
    }
    setSendCodeIsAbled(false);
  };
  /**
   * removeTimer - setCountDown(false)
   */
  const removeTimer = () => {
    setCountDown(false);
    clearTimer();
}

  /**
   * confirmApproveCode
   */
  function confirmApproveCode() {
    var smsOrMailVal = document.getElementById("confirmCode").value;
    var url;

    if (debugMode) {
      if (!loginLock) url = URI.CONFIRM_LOGIN_CODE_DEBUG;
      else url = URI.CONFIRM_UNLOCK_CODE_DEBUG;
    } else {
      if (!loginLock) url = URI.CONFIRM_LOGIN_CODE;
      else url = URI.CONFIRM_UNLOCK_CODE;
    }

    var sendData;
    if (!loginLock) sendData = { confirmVal: smsOrMailVal };
    else
      sendData = {
        password: smsOrMailVal,
        valueType: valueType,
        tcknOrVknOrSicil: valueForUnlock,
      };

    post(url, sendData)
      .then(function(response) {
        removeTimer();
        if (response.data.status === "OK") {
          if (!loginLock) {
            setFirstLogin(false);
            localStorage.removeItem(Globals.TOKEN);
            setApprovedUserToken(response.data.token);
            setExpiredPassword(response.data.expiredPassword);
            setShowMessage(true);
          } else {
            setFirstLogin(false);
            setLoginLock(false);
            alertBox(
              "",
              "Tekrar şifre girişi yapabilirsiniz",
              Globals.ALERT_SUCCESS,
              intl
            );
          }
        } else {
          alertBox("", "Hatalı giriş yaptınız", Globals.ALERT_ERROR, intl);
        }
      })
      .catch(function(error) {
        if ("ER170" === checkHttpStatus(error, props.intl)) {
          setCountDown(false);
          setConfirmCodeBlock(true);
        }
      });
  }

  /**
   *
   * charCodeControl
   * @param event
   */
  const charCodeControl = (event) => {
    var charCode = event.charCode
      ? event.charCode
      : event.keyCode
      ? event.keyCode
      : event.which
      ? event.which
      : 0;
    var valid = charCode >= 48 && charCode <= 57;
    if (!valid) {
      event.preventDefault();
    }
  };

  /**
   *
   * @return {string}
   */
  function getPureUrlTemplate() {
    return window.location.origin;
  }

  /**
   * goToEgovern
   */
  function goToEgovern() {
    window.location = URI.EDEVLET_LOGIN;
  }

  const getApproveCode = (fromEdevlet) => {
  

    var investorType = localStorage.getItem("InvestorType");
    var country = localStorage.getItem("Country");
    setInvestorType(investorType);
    setCountry(country);
    var url;
    if (!loginLock) url = URI.GET_LOGIN_CODE;
    else url = URI.GET_UNLOCK_CODE;

    if (country === "TR") {
      if (investorType === "R") {
        setSmsIsAbled(true);
        setEpostaIsAbled(false);
      } else {
        setEpostaIsAbled(true);
        setSmsIsAbled(false);

      }
    } else {
      setEpostaIsAbled(true);
      setSmsIsAbled(false);
    }

 
    enableSpinner();
    var apiCall;
    if (!loginLock) apiCall = get(url);
    else
      apiCall = post(url, {
        valueType: valueType,
        tcknOrVknOrSicil: valueForUnlock,
      });
    apiCall
      .then(function(response) {
        disableSpinner();
         if (response.data.status === "OK") {
          if (!loginLock) {
            localStorage.removeItem(Globals.TOKEN);
            localStorage.setItem(Globals.TOKEN, response.data.token);
          }
          setCountDown(true);
          setFirstInitialize(false);
          setConfirmCodeBlock(false);
          if (!loginLock) {
            if (country !== "TR") {
              document.getElementById("pleasecode").innerHTML =
                "e-Posta adresinize gönderilen onay " + "kodunuzu giriniz.";
            } else {
              if (investorType === "R") {
                document.getElementById("pleasecode").innerHTML =
                  response.data.gsmNo +
                  " numaralı telefonunuza " +
                  "gönderilen SMS onay kodunu giriniz.";
              } else {
                document.getElementById("pleasecode").innerHTML =
                  "e-Posta adresinize gönderilen onay " + "kodunuzu giriniz.";
              }
            }
          } else {
            document.getElementById("pleasecode").innerHTML =
              "e-Posta adresinize gönderilen onay kodunuzu giriniz.";
              setEpostaIsAbled(true)
              setSmsIsAbled(false)
          }

          document.getElementById("infoArea3").innerHTML =
            "* Gönderilen onay kodu mesajlarının geçerlilik süresi 3 " +
            "dakikadır. Tekrar onay kodu talep etmeniz için gereken süreniz:";
        } else {
          this.setState({ sendCode: false });
        }
      })
      .catch(function(error) {
        // handle error
        setSmsIsAbled(false)
        setEpostaIsAbled(false)
        disableSpinner();
        checkHttpStatus(error, props.intl);
      });
  };

  const shouldSendCodeToSms = () => {
    enableSpinner();
    var apiCall;
    if (!loginLock) apiCall = get(URI.GET_LOGIN_SMS_CODE);
    else
      apiCall = post(URI.GET_UNLOCK_CODE, {
        valueType: valueType,
        tcknOrVknOrSicil: valueForUnlock,
      });

    apiCall
      .then(function(response) {
        disableSpinner();
        if (response.data.status === "OK") {
          if (!loginLock) {
            localStorage.removeItem(Globals.TOKEN);
            localStorage.setItem(Globals.TOKEN, response.data.token);
          }
          setCountDown(true);
          setFirstInitialize(false);
          setConfirmCodeBlock(false);
           setEpostaIsAbled(true)
       
          if (!loginLock) {
            document.getElementById("pleasecode").innerHTML =
              response.data.gsmNo +
              " numaralı telefonunuza gönderilen SMS onay kodunu giriniz.";
          }
          document.getElementById("infoArea3").innerHTML =
            "* Gönderilen onay kodu mesajlarının geçerlilik süresi 3 dakikadır. " +
            "Tekrar onay kodu talep etmeniz için gereken süreniz:";
        } else {
          this.setState({ sendCode: false });
        }
      })
      .catch(function(error) {
        disableSpinner();
        checkHttpStatus(error, props.intl);
      });
  };

  const shouldSendCodeToEmail = () => {
    enableSpinner();
    var apiCall;
    if (!loginLock) apiCall = get(URI.GET_LOGIN_EMAIL_CODE);
    else
      apiCall = post(URI.GET_UNLOCK_CODE, {
        valueType: valueType,
        tcknOrVknOrSicil: valueForUnlock,
      });

    apiCall
      .then(function(response) {
        disableSpinner();
        if (response.data.status === "OK") {
          if (!loginLock) {
            localStorage.removeItem(Globals.TOKEN);
            localStorage.setItem(Globals.TOKEN, response.data.token);
          }
          setCountDown(true);
          setFirstInitialize(false);
          setConfirmCodeBlock(false);
          setSmsIsAbled(true)
        
          if (!loginLock) {
            document.getElementById("pleasecode").innerHTML =
              "e-Posta adresinize gönderilen onay kodunuzu giriniz.";
          }
          document.getElementById("infoArea3").innerHTML =
            "* Gönderilen onay kodu mesajlarının geçerlilik süresi 3 dakikadır. " +
            "Tekrar onay kodu talep etmeniz için gereken süreniz:";
        } else {
          this.setState({ sendCode: false });
        }
      })
      .catch(function(error) {
        disableSpinner();
        checkHttpStatus(error, props.intl);
      });
  };

  if (showRegistration) {
    if (debugMode) {
      return <Redirect to="/auth/registration?debugMode=true" />;
    } else {
      return <Redirect to="/auth/registration" />;
    }
  }

  /**
   * loadHomePage
   */
  function loadHomePage(isExists) {

    localStorage.setItem(Globals.TOKEN, approvedUserToken);
    if (expiredPassword)
      setUpdatePassword(true);
    else {
      if (checked) {
        localStorage.setItem("mkkSicilNo", document.getElementById("mkkSicilNo").value);
        localStorage.setItem("rememberMe", true);
      }
      else {
        localStorage.removeItem("mkkSicilNo");
        localStorage.setItem("rememberMe", false);
      }
      get(URI.GET_MENU_ITEMS)
        .then(function (response) {
          var menuConf = {
            header: {
              self: {},
              items: [

                        ]
            },
            aside:{
              self: {},
              items:[]
                    }
          };
          var menuList = response.data.menuList;
          for(var i=0;i<menuList.length;i++){
            if(menuList[i].subMenuList !== null && menuList[i].subMenuList.length > 0) {
              var parentMenu = {
                title: menuList[i].label,
                root: true,
                alignment: "left",
                page: "#",
                bullet: "dot",
                iconUrl: menuList[i].iconUrl,
                submenu: []
              };
              for(var j=0;j<menuList[i].subMenuList.length;j++){
                var subMenu = {
                  title: menuList[i].subMenuList[j].label,
                  root: true,
                  alignment: "left",
                  page: menuList[i].subMenuList[j].url,
                  bullet: "dot",
                  iconUrl: menuList[i].subMenuList[j].iconUrl
                };
                parentMenu.submenu.push(subMenu);
              }
              menuConf.aside.items.push(parentMenu);
            } else {
              var parentMenu = {
                title: menuList[i].label,
                root: true,
                alignment: "left",
                page: menuList[i].url,
                bullet: "dot",
                iconUrl: menuList[i].iconUrl
              };
              menuConf.aside.items.push(parentMenu);
            }
          }

          dispatch(builder.actions.setMenuConfig(menuConf));
          props.isLogedIn();
        })
        .catch(function (error) {
          checkHttpStatus(error,null);
        });
    }
    if(isExists){
      failedLoginShownStatusUpdateCall()
      localStorage.removeItem("IsExistsFailedLogin")
      localStorage.removeItem("FailedLoginDateList")
    }
  }

  /**
   *
   * @param menuList
   * @return result
   */
  const getHpksParentMenu = (menuList) => {
    var result = null;
    if(menuList) {
      for(var i=0;i<menuList.length;i++){
        if(menuList[i].isHpksParentMenu) {
          result = menuList[i];
        }
      }
    }
    return result;
  };



  /**
   *
   * @param menuList
   * @return result
   */
  const getYrtsParentMenu = (menuList) => {
    var result = null;
    if(menuList) {
      for(var i=0;i<menuList.length;i++){
        if(menuList[i].isYrtsParentMenu) {
          result = menuList[i];
        }
      }
    }
    return result;
  };

  /**
   *
   * @param menuList
   * @return result
   */
  const getKfsParentMenu = (menuList) => {
    var result = null;
    if(menuList) {
      for(var i=0;i<menuList.length;i++){
        if(menuList[i].isKfsParentMenu) {
          result = menuList[i];
        }
      }
    }
    return result;
  };

  /**
   *
   * @param menuList
   * @return result
   */
  const getElusParentMenu = (menuList) => {
    var result = null;
    if(menuList) {
      for(var i=0;i<menuList.length;i++){
        if(menuList[i].isElusParentMenu) {
          result = menuList[i];
        }
      }
    }
    return result;
  };


  /**
   *
   * @param showMessage
   */
  function showGreetingMessage(showMessage) {
const isExists =
    (localStorage.getItem("IsExistsFailedLogin") || "").toLowerCase() === "true";
  let failedLoginList = [];
  try {
    failedLoginList = JSON.parse(localStorage.getItem("FailedLoginDateList") || "[]");
    if (!Array.isArray(failedLoginList)) failedLoginList = [];
  } catch (e) {
    failedLoginList = [];
  }

  const list = failedLoginList.slice(0, 5);

  console.log("5li parça",list)
  const formatDate = (s) => {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return String(s ?? "");
    return d.toLocaleString("tr-TR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };



    return <Dialog
        open={showMessage}
        aria-labelledby="form-dialog-title-2"
        fullWidth={true}
        style={{ textAlign: "left" }}
      >
        <DialogTitle id="form-dialog-title-2">{props.intl.
      formatMessage({ id: "AUTH.VALIDATION.GREETING_MESSAGE_TITLE" })}</DialogTitle>
      <DialogContent>
          <DialogContentText>
              {localStorage.getItem('HelloMsgNameSurnameTitle')}
          </DialogContentText>
        <DialogContentText>
          {localStorage.getItem('HelloMsg')}
        </DialogContentText>
      
        {isExists && list.length > 0 && (
          <div
            style={{
              marginTop: 16,
              backgroundColor: "#fff2f0", // Çok açık kırmızı arka plan
              border: "1px solid #ffccc7", // İnce kırmızı çerçeve
              borderRadius: "8px", // Köşeleri yumuşatma
              padding: "12px 16px", // İç boşluk
              fontSize: "14px",
              color: "#4a4a4a",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: 600,
                color: "#cf1322", // Başlık için daha koyu kırmızı
                marginBottom: 8,
              }}
            >
              Son Hatalı Giriş Denemeleri
            </div>

            <ul style={{ margin: 0, padding: 0, listStyleType: "none" }}>
              {list.map((dt, i) => (
                <li
                  key={`${dt}-${i}`}
                  style={{
                    marginBottom: 4,
                    paddingLeft: "12px",
                    position: "relative",
                    color: "#595959",
                  }}
                >
                  {/* Özel nokta (bullet) tasarımı */}
                  <span
                    style={{
                      position: "absolute",
                      left: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "4px",
                      height: "4px",
                      backgroundColor: "#ff4d4f",
                      borderRadius: "50%",
                    }}
                  />
                  {formatDate(dt)}
                </li>
              ))}
            </ul>
          </div>
        )}
      
      
      </DialogContent>
      
      <DialogActions style={{ padding: 16 }}>
        <Button color="primary" id='welcomeButton2'
          onClick={() => setShowMessage(false)}
        >
          {props.intl.formatMessage({ id: "COMMON.BUTTON_CANCEL" })}
        </Button>
        <Button
          variant="contained" color="primary" id='welcomeButton1'
          onClick={() => {
            loadHomePage(isExists)
          }}
        >
          {props.intl.formatMessage({ id: "COMMON.BUTTON_CONTINUE" })}
        </Button>
      </DialogActions>
    </Dialog>
  }

  return (
    <>
      <BirthDatePickerDialog 
        open={memberState.isBirthDateOpen} 
        value={memberState.birthDate} 
        onChange={(newDate) => {
          setMemberState(prevState => ({
            ...prevState,
            birthDate: newDate 
          }));
        }}
        loading={memberState.loading}
        onSave={saveBirthDate}
        onClose={(newDate) => {
          setMemberState(prevState => ({
            ...prevState,
            isBirthDateOpen:false
          }));
        }}
    />
      <div className="kt-login__head">

      </div>

      <div className="kt-login__body" style={!notxs ? {margin:0} : null}>
        <div className="kt-login__form">
          <div className="kt-login__title" style={!notxs ? {margin:0} : null}>
            <h3>
              {/* https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage */}
              <FormattedMessage id="AUTH.LOGIN.TITLE" />
            </h3>
          </div>

          <Formik
            initialValues={{
              mkkSicilNo: localStorage.getItem("mkkSicilNo") !== null ? localStorage.getItem("mkkSicilNo") : "",
              password: ""
            }}
            validate={values => {
              const errors = {};

              if (!values.mkkSicilNo) {
                // https://github.com/formatjs/react-intl/blob/master/docs/API.md#injection-api
                errors.mkkSicilNo = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
              }
              if(!loginLock) {
                if (!values.password) {
                  errors.password = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                }
              }
              if (values.mkkSicilNo && (values.mkkSicilNo.toString().length > 11 || values.mkkSicilNo.
                  toString().length < 8 || values.mkkSicilNo.toString().length === 9 || isNaN(values.mkkSicilNo))) {
                errors.mkkSicilNo = intl.formatMessage({
                  id: "AUTH.VALIDATION.INVALID_FIELD"
                });
              }
              if (values.mkkSicilNo && !Regex.TCKN_VKN_IDENTITY.test(values.mkkSicilNo)) {
                errors.mkkSicilNo = intl.formatMessage({
                  id: "AUTH.VALIDATION.INVALID_FIELD"
                });
              }

              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              if(captchaCount<2 || (captchaCount>=2 && validUser)){

                enableLoading();
                var postData = {};
                if (values.mkkSicilNo.toString().length === 8) {
                  postData['valueType'] = "IDENTITY";
                  setValueType('IDENTITY');
                }else if (values.mkkSicilNo.toString().length === 10) {
                  postData['valueType'] = "VKN";
                  setValueType('VKN');
                }else if (values.mkkSicilNo.toString().length === 11) {
                  postData['valueType'] = "TCKN";
                  setValueType('TCKN');
                }

                postData['tcknOrVknOrSicil'] = values.mkkSicilNo;
                setValueForUnlock(values.mkkSicilNo);
                postData['password'] = values.password;

                if(!loginLock) {
                  post(URI.LOGIN, postData).then(function (response) {
                      // localStorage.clear();

                            localStorage.setItem(Globals.TOKEN, response.data.token);
                            if (response.data.investorType === 'R') {
                                localStorage.setItem("NameSurname", response.data.name + ' ' + response.data.surname);
                                localStorage.setItem("HelloMsgNameSurnameTitle", 'Hoş geldiniz Sayın ' + response.data.name + ' ' + response.data.surname);
                            } else {
                                localStorage.setItem("NameSurname", response.data.title);
                                localStorage.setItem("HelloMsgNameSurnameTitle", 'Hoş geldiniz Sayın ' + response.data.title);
                            }
                            localStorage.setItem("HelloMsg", response.data.helloMsg);
                            localStorage.setItem("SicilNo", response.data.sicilNo);
                            localStorage.setItem("InvestorType", response.data.investorType);
                            localStorage.setItem("QualificationStat", response.data.qualificationStat);
                            localStorage.setItem("Country", response.data.country);
                            localStorage.setItem("IsExistsFailedLogin",String(!!response.data.existsFailedLogin));
                            localStorage.setItem("FailedLoginDateList",JSON.stringify(response.data.failedLoginDateList || []));
                            dispatch(auth.actions.setFooters(response.data.fundWarnMessageMap));

                      if (response.data.status === Globals.UNREGISTERED_USER) {
                        setShowRegistration(true);
                      }
                            else {
                        setFirstLogin(true);
                        getApproveCode(false);
                      }
                      disableLoading();
                      setSubmitting(false);

                      resetCaptcha();
                    
                        }).catch(function (error) {
                      setCaptchaCount(captchaCount+1);
                      disableLoading();
                      setSubmitting(false);
                      var err = checkHttpStatus(error, props.intl);
                      if('ER173' === err)
                                setLoginLock(true);

                      resetCaptcha();


                    });
                }else{
                  disableLoading();
                  setSubmitting(false);
                  setFirstLogin(true);
                  getApproveCode(false);
                }
              
                }else{
                if(!waitingCaptchaService){
                  alertBox("Hata", "Lütfen captcha alanını doldurunuz.", Globals.ALERT_ERROR, intl);
                }
                setSubmitting(false);
              }
            }

              }
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form
                noValidate={true}
                autoComplete="off"
                className="kt-form"
                style={{ marginTop: 16, marginBottom: 16  }}
                onSubmit={handleSubmit}
              >
                <div className="kt-login__divider">
                  <div className="kt-divider">
                    <span />

                    <span />
                  </div>
                </div>

                <div className="form-group" style={{ height: 94}}>
                  <TextField
                    defaultValue={
                      localStorage.getItem("mkkSicilNo") === null
                        ? ""
                        : localStorage.getItem("mkkSicilNo")
                    }
                    id="mkkSicilNo"
                    type="text"
                    label="TCKN/VKN/MKK Sicil Numarası"
                    margin="normal"
                    className="kt-width-full"
                    name="mkkSicilNo"
                    variant="outlined"
                    inputProps={{ maxLength: 11 }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onKeyPress={(event) => {
                      charCodeControl(event);
                    }}
                    helperText={errors.mkkSicilNo}
                    error={Boolean(touched.mkkSicilNo && errors.mkkSicilNo)}
                  />
                </div>

                <div className="form-group">
                  <TextField
                    margin="normal"
                    label="Şifre"
                    className="kt-width-full"
                    name="password"
                    variant="outlined"
                    inputProps={{
                      maxLength: 6,
                      autoComplete: "new-password",
                      type: "password",
                    }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    helperText={touched.password && errors.password}
                    error={Boolean(touched.password && errors.password)}
                  />
                </div>

                {captchaCount >= 2 ? (
                  <ReCAPTCHA
                    sitekey={siteKey}
                    onChange={handleOnChangeCaptcha}
                    ref={captcha}
                    onExpired={expiredCaptcha}
                  />
                ) : null}

                <div
                  className="kt-login__actions"
                  style={!notxs ? { margin: 0 } : null}
                >
                  <Link
                    onClick={() => setShowPassInfo(true)}
                    className="kt-link kt-login__link-forgot"
                    style={{ color: "#aa3323", fontWeight: "bold"}}
                  >
                    <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
                  </Link>
                </div>
                <div style={{ 
                  display: "flex", 
                  justifyContent: "space-between", 
                  alignItems: "center", 
                  width: "100%" 
                }}>
                  <FormControlLabel
                    style={{ marginBottom: 0 }}
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={handleCheckBox}
                        value={checked}
                        color="primary"
                      />
                    }
                    label={props.intl.formatMessage({
                      id: "AUTH.LOGIN.REMEMBER_ME",
                    })}
                  ></FormControlLabel>
                  <Button
                    id="kt_login_signin_submit"
                    type="submit"
                    color="primary"
                    size="large"
                    variant="contained"
                    fullWidth
                    disabled={isSubmitting}
                    classes={{ label: classes.whiteText }}
                    className={`btn btn-secondary btn-elevate ${clsx({
                      "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading,
                    })}`}
                    style={{ width: "45%" }}
                  >
                    {!loginLock ? (
                      <FormattedMessage id="COMMON.BUTTON_CONTINUE" />
                    ) : (
                      <FormattedMessage id="COMMON.BUTTON_SEND" />
                    )}
                  </Button>
                </div>

                <div>
                  <Dialog
                    open={firstLogin}
                    // onClose={handleClose4}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    style={{ textAlign: "left" }}
                    onExit={() => setFirstInitialize(true)}
                  >
                    <DialogTitle id="form-dialog-title">
                      {props.intl.formatMessage({
                        id: "AUTH.VALIDATION.ENTER_WITH_APPROVE_CODE",
                      })}
                    </DialogTitle>
                    <DialogContent>
                      <Typography gutterBottom variant="body1">
                        {!loginLock
                          ? "Sayın " + localStorage.getItem("NameSurname")
                          : ""}
                      </Typography>
                      <Typography
                        gutterBottom
                        variant="body1"
                        id="pleasecode"
                      ></Typography>

                      <TextField
                        autoFocus
                        autoComplete="off"
                        margin="dense"
                        id="confirmCode"
                        label="Onay Kodu"
                        type="numeric"
                        variant="outlined"
                        onChange={(event) => handleApproveCodeInput(event)}
                        onKeyPress={(event) => {
                          charCodeControl(event);
                        }}
                      />

                      <div>
                        <br />
                        <Button
                          color="primary"
                          onClick={() => {
                            setFirstLogin(false);
                            removeTimer();
                          }}
                        >
                          {props.intl.formatMessage({
                            id: "COMMON.BUTTON_CANCEL",
                          })}
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          id="approveButton"
                          disabled={!sendCodeIsAbled && !firstInitialize}
                          onClick={() => {
                            confirmApproveCode();
                          }}
                        >
                          {props.intl.formatMessage({
                            id: "COMMON.BUTTON_ENTER",
                          })}
                        </Button>
                      </div>

                      <div>
                        <br />
                        <DialogContentText style={{ marginBottom: 0 }}>
                          <Typography
                            variant="subtitle1"
                            id="infoArea3"
                          ></Typography>
                        </DialogContentText>
                             {countDown  ? (intervalFunc(3,() =>timeIsUp()),
                                                        setCountDown(false),setSendCodeIsAbled(true)) : null}
                                                    
                                                    <span id="timerArea" ></span>               

                      </div>
                      {/* <span className="form-text" id="infoArea3">
                          </span> */}
                      <div>
                        <br />
                        <Button
                          color="primary"
                          disabled={sendCodeIsAbled && !confirmCodeBlock}
                          onClick={() => {
                            removeTimer();
                            getApproveCode(edevletLogin);
                          }}
                        >
                          {
                       
                          smsIsAbled ? "Onay kodunu telefonuma gönder" :  "Onay kodunu e-posta adresime gönder" }
                        </Button>
                        <br />

                        {country === "TR" && investorType === "R" ? (
                          <Button
                            color="primary"
                            onClick={() => {
                              removeTimer();
                              shouldSendCodeToEmail();
                            }}
                          >
                            Onay kodunu e-posta adresime gönder
                          </Button>
                        ) : (
                          <Button
                            color="primary"
                            onClick={() => {
                              removeTimer();
                              shouldSendCodeToSms();
                            }}
                          >
                            Onay kodunu telefonuma gönder
                          </Button>
                        )}
                      </div>
                    </DialogContent>
                  </Dialog>
                  {showGreetingMessage(showMessage)}
                  <ChangePassword open={updatePassword} />
                </div>
              </form>
            )}
          </Formik>

          <div className="kt-login__options">
            <button 
                className="btn kt-btn"
                style={{ 
                  width: "100%", 
                  backgroundColor: 'rgb(246, 78, 96)', 
                  borderColor: 'rgb(246, 78, 96)', 
                  color: '#fff', 
                  padding: "1.25rem 2.25rem",
                  marginBottom: "0.75rem",
                  fontFamily: "'Poppins-Light', sans-serif",
                  fontSize: '1.1rem', 
                  fontWeight: 300, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  borderWidth: '1px',
                  borderStyle: 'solid'
                }}
                onClick={goToEgovern}
              >
                <img
                  style={{ height: 30, marginRight: '12px' }} // Logo boyutu ve boşluğu ayarlandı
                  alt="Logo"
                  src={toAbsoluteUrl("/media/logos/edevletlogo-white.png")}
                />
                <span style={{ fontFamily: 'inherit', fontWeight: 'inherit' }}>
                  e-Devlet ile Giriş
                </span>
              </button>
          </div>
          <div>
            <Dialog
              open={showPassInfo}
              aria-labelledby="form-dialog-title"
              fullWidth={true}
              style={{ textAlign: "left" }}
            >
              <DialogTitle id="form-dialog-title">
                <Typography variant='h5' align='center' style={{color: '#aa3323',fontWeight:'bold'}}>
                  Şifremi Nasıl Oluştururum?
                </Typography>
              </DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography classes={{h6:classes.fontLight}} variant='h6' display='inline'>
                     e-YATIRIMCI uygulamasına giriş yapabilmek için ihtiyacınız olan MKK Sicil ve Şifresi kişiye özel olarak oluşturulmaktadır.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography classes={{h6:classes.fontLight}} variant='h6' display='inline'>
                      MKK Sicil numaranız varsa,
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography classes={{h6:classes.fontLight}} variant='h6' display='inline'  style={{marginLeft: 3}} >
                    &nbsp; &nbsp;  <span>●</span>  &nbsp; e-YATIRIMCI uygulamasına e-Devlet ile giriş yaptıktan sonra Ayarlar/Güvenlik İşlemleri adımından şifrenizi oluşturabilir ya da değiştirebilirsiniz.
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography classes={{h6:classes.fontLight}} variant='h6' display='inline' style={{marginLeft: 3}}>
                    &nbsp; &nbsp;  <span>●</span>  &nbsp; MKK Sicil Şifrenizi 444 0 655 numaralı MKK Çözüm Merkezini arayarak da oluşturabilirsiniz.               
                     </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography classes={{h6:classes.fontLight}} variant='h6' display='inline'>
                      MKK Sicil numaranız bulunmuyorsa, yatırım kuruluşlarında yatırım hesabı açtırarak sicil numarasına sahip olabilirsiniz.                    
                     </Typography>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions style={{ padding: 16 }}>
                <Button
                  variant="contained" color="primary"
                  onClick={() => {setShowPassInfo(false); setSmsIsAbled(false); setEpostaIsAbled(false) }}
                >
                  {props.intl.formatMessage({ id: "COMMON.MODAL_CLOSE" })}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
}

export default injectIntl(
  connect(
    null,
    auth.actions
  )(Login)
);